import './Account.css';
import Orders from "./sub/Orders/Orders.jsx";
import ShipmentDetails from "./sub/DeliveryDetails/ShipmentDetails.jsx";
import Settings from "./sub/Settings/Settings.jsx";
import {useNavigate} from "react-router-dom";
import {useMediaQuery} from "react-responsive";
import {useEffect, useState} from "react";
import {getUserFirstName} from "../../CustomerHandler.js";
import {Helmet} from "react-helmet-async";

const titles = {
    orders: "Konto – Zamówienia | Lumestore",
    reviews: "Konto – Opinie | Lumestore",
    "shipment-details": "Konto – Dane dostawy | Lumestore",
    settings: "Konto – Ustawienia | Lumestore",
};

const desc = {
    orders: "Twoje zamówienia w Lumestore.",
    reviews: "Twoje opinie o produktach w Lumestore.",
    "shipment-details": "Dane dostawy i adresy w Lumestore.",
    settings: "Ustawienia konta w Lumestore.",
};

export default function Account({ currentTab }) {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [name, setName] = useState("");

    useEffect(() => {
        const token = sessionStorage.getItem("customerAccessToken");
        const fetchName = async () => {
            const fetchedName = await getUserFirstName(token);
            setName(fetchedName);
        };

        fetchName();
    }, []);

    const navigate = useNavigate();

    const title = titles[currentTab] || "Konto | Lumestore";
    const description = desc[currentTab] || "Panel konta użytkownika w Lumestore.";
    const canonical =
        "https://lumestore.pl/konto/" +
        (currentTab === "orders"
            ? "zamowienia"
            : currentTab === "reviews"
                ? "opinie"
                : currentTab === "shipment-details"
                    ? "dostawa"
                    : currentTab === "settings"
                        ? "ustawienia"
                        : "");

    return (
        <div id="account">
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta name="robots" content="noindex,follow" />
                <link rel="canonical" href={canonical} />
                <meta property="og:url" content={canonical} />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
            </Helmet>

            <div id="account-nav">
                <div id="account-nav-labels-container">
                    <span id="account-nav-label-1">Cześć,</span>
                    <span id="account-nav-label-2">{name}</span>
                </div>
                <div id="account-nav-bttns-wrapper">
                    <div
                        id="account-nav-orders-bttn"
                        className={`account-nav-bttn${
                            currentTab === "orders" ? "--active" : ""
                        }`}
                        onClick={() => navigate("/konto/zamowienia")}
                    >
                        <div
                            id="account-nav-orders-icon"
                            className="account-nav-icon"

                        >
                            <img loading="lazy" src='/images/orders-icon.webp' alt="" />

                        </div>
                        <span id="account-nav-orders-label" className="account-nav-label">
              Zamówienia
            </span>
                    </div>
                    {/* Opinie wyłączone */}
                    <div
                        id="account-nav-delivery-bttn"
                        className={`account-nav-bttn${
                            currentTab === "shipment-details" ? "--active" : ""
                        }`}
                        onClick={() => navigate("/konto/dostawa")}
                    >
                        <div
                            id="account-nav-delivery-icon"
                            className="account-nav-icon"

                        >
                            <img loading="lazy" src='/images/shipment-icon.webp' alt="" />

                        </div>
                        <span id="account-nav-delivery-label" className="account-nav-label">
              Dane do zamówień
            </span>
                    </div>
                    <div
                        id="account-nav-settings-bttn"
                        className={`account-nav-bttn${
                            currentTab === "settings" ? "--active" : ""
                        }`}
                        onClick={() => navigate("/konto/ustawienia")}
                    >
                        <div
                            id="account-nav-settings-icon"
                            className="account-nav-icon"

                        >
                            <img loading="lazy" src='/images/settings-icon.webp' alt="" />

                        </div>
                        <span id="account-nav-settings-label" className="account-nav-label">
              Ustawienia
            </span>
                    </div>
                </div>
            </div>
            <div id="account-main">
                {currentTab === "orders" && <Orders />}
                {/* {currentTab === 'reviews' && <Reviews/>} */}
                {currentTab === "shipment-details" && <ShipmentDetails />}
                {currentTab === "settings" && <Settings />}
            </div>
        </div>
    );
}
